module.exports = __webpack_public_path__ + "img/upload_file.ac3498c9.svg";